import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = { class: "mb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GlobalPartnersMapCard = _resolveComponent("GlobalPartnersMapCard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_GlobalPartnersMapCard, { ccode: _ctx.ccode }, null, 8, ["ccode"])
    ])
  ]))
}